// extracted by mini-css-extract-plugin
export var label = "_fw-2";
export var slideContainer = "_fw-0";
export var slider = "_fw-1";